import BaseApi from './BaseApi';

const baseUrl = 'api/FCM/';

class FCMService {
    
    static getNotifies(page: number, key:number): Promise<any> {
        return BaseApi.get(`${baseUrl}notification/${key}/${page}`);
    }

    static getTopsAndCount(key:number): Promise<any> {
        return BaseApi.get(`${baseUrl}topsAndCount/${key}`);
    }
    static setView(id:number): Promise<any> {
        return BaseApi.patch(`${baseUrl}markNotification/${id}`);
    }
    static setAllView(): Promise<any> {
        return BaseApi.patch(`${baseUrl}markAllNotificationAsRead`);
    }
}

export default FCMService;